import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    padding: 5.55em 0 ;
    position: relative;
    text-align: center;
    font-weight: 700;

    .background {
        position: absolute;
        top: 0%;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: right;
    }

    .hero-txt {
        margin: 0 auto;

        .title {
            position: relative;
            font-size: 3.35em;
            margin-bottom: .5em;
            z-index: 2;
            max-width: 100vw;
            line-height: unset;

            .underline-large {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background-image: url('/images/employerArticles/underline.svg');
                background-repeat: no-repeat;
                background-position: bottom center;
                background-size: contain;
                z-index: -1;
            }

            .underline-small {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background-image: url('/images/employee-articles/underline.svg');
                background-repeat: no-repeat;
                background-position: bottom center;
                background-size: contain;
                z-index: -1;
            }
        }

        .subtitle {
            color:#ffffff;
            font-size: 1.2em;
            font-weight: 300;
            line-height: 1.5;
        }

    }

    @media all and (max-width: ${variables.tabletL}) {
        padding: 0;

        .background {
            position: relative;
            height: 15em;
        }
        .hero-txt {
            position: relative;
            top: -1.2em;

            .subtitle {
                color:#000000;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        .hero-txt {
            padding: 0 1em;

            .title-wrapper{
                .title {
                    font-size: 3em;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileS}) {
        .hero-txt {
            .title-wrapper{
                .title {
                    font-size: 2.4em;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileXS}) {
        .hero-txt {
            .title-wrapper{
                .title {
                    font-size: 1.8em;
                }
            }
        }
    }
`;